import { Send, Gavel, ShieldAlert } from "lucide-react";
import ReportOffPlatform from "./ReportOffPlatform";
import { Input } from "./ui/input";
import { Button } from "./ui/button";

export default function OrderChat({ messages, msgBody, setMsgBody, sendMessage, currentUserId, adminMode = false, disputeOpen = false, orderId, canReport = false, viewerRole = "restaurant" }) {
  const bubble = (m) => {
    if (m.sender_role === "admin") return "bg-slate-900 text-white border border-amber-400";
    if (m.sender_role === "system") return "bg-amber-50 text-amber-900 border border-amber-300";
    return m.sender_id === currentUserId ? "bg-orange-500 text-white" : "bg-slate-100 text-slate-800";
  };
  return (
    <div className={`ga-card p-6 no-print ${adminMode ? "border-2 border-slate-900" : ""}`}>
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <h2 className="font-display text-xl font-bold text-slate-900">Chat ordine</h2>
        {disputeOpen && (
          <span className="inline-flex items-center gap-1 rounded-full bg-slate-900 text-amber-300 px-2.5 py-1 text-[10px] font-mono uppercase tracking-widest" data-testid="chat-mediation-badge">
            <Gavel className="w-3 h-3" /> Mediazione admin attiva
          </span>
        )}
      </div>
      {disputeOpen && !adminMode && (
        <div className="mt-2 text-xs text-slate-600">Durante la contestazione l'amministratore legge questa chat e può intervenire per chiedere chiarimenti.</div>
      )}
      <div className="mt-4 max-h-80 overflow-y-auto space-y-2 pr-1" data-testid="chat-container">
        {messages.length === 0 && <div className="text-sm text-slate-500">Nessun messaggio ancora.</div>}
        {messages.map(m => (
          <div key={m.id} className={`flex ${m.sender_role === "system" ? "justify-center" : m.sender_id === currentUserId ? "justify-end" : "justify-start"}`} data-testid={`chat-msg-${m.id}`}>
            <div className={`max-w-[80%] px-3 py-2 rounded-2xl text-sm ${bubble(m)}`}>
              <div className="text-[10px] font-mono uppercase tracking-widest opacity-70 flex items-center gap-1">{m.sender_role === "admin" && <Gavel className="w-3 h-3" />}{m.sender_role === "system" && <ShieldAlert className="w-3 h-3" />}{m.sender_name}{m.masked && <span className="ml-1 rounded bg-amber-200 text-amber-900 px-1 normal-case tracking-normal" data-testid={`chat-masked-${m.id}`}>contatti nascosti</span>}</div>
              <div className="mt-0.5">{m.body}</div>
              {canReport && m.sender_id && m.sender_id !== currentUserId && m.sender_role !== "admin" && m.sender_role !== "system" && (
                <ReportOffPlatform orderId={orderId} messageId={m.id} compact viewerRole={viewerRole} />
              )}
            </div>
          </div>
        ))}
      </div>
      <form onSubmit={sendMessage} className="mt-4 flex gap-2">
        <Input value={msgBody} onChange={e => setMsgBody(e.target.value)} placeholder={adminMode ? "Scrivi come amministratore..." : "Scrivi un messaggio..."} data-testid="chat-input" />
        <Button type="submit" className="ga-btn-primary rounded-full" data-testid="chat-send-button"><Send className="w-4 h-4" /></Button>
      </form>
      {canReport && viewerRole === "supplier" && (
        <div className="mt-4 rounded-xl border-2 border-amber-200 bg-amber-50 p-4 flex items-center justify-between gap-3 flex-wrap" data-testid="supplier-offplatform-reminder">
          <div className="min-w-0 flex items-start gap-2">
            <ShieldAlert className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
            <div>
              <div className="font-semibold text-amber-900 text-sm">Ti propongono di concludere fuori da AstaAlimentare?</div>
              <div className="text-xs text-amber-800 mt-0.5">Fuori piattaforma <b>non sei tutelato</b> sul pagamento (nessun importo bloccato, nessuna mediazione). Ricorda gli impegni accettati alla registrazione: <b>clausola di conformità v1.1</b> e <b>divieto di elusione</b> (12 mesi, penale pari alla commissione elusa). Se è l'acquirente a proporlo, segnalalo.</div>
            </div>
          </div>
          <ReportOffPlatform orderId={orderId} viewerRole={viewerRole} />
        </div>
      )}
      {canReport && viewerRole !== "supplier" && (
        <div className="mt-4 rounded-xl border-2 border-red-200 bg-red-50 p-4 flex items-center justify-between gap-3 flex-wrap" data-testid="report-offplatform-box">
          <div className="min-w-0 flex items-start gap-2">
            <ShieldAlert className="w-5 h-5 text-red-600 shrink-0 mt-0.5" />
            <div>
              <div className="font-semibold text-red-900 text-sm">Ti propongono di pagare o ordinare fuori da AstaAlimentare?</div>
              <div className="text-xs text-red-800 mt-0.5">Telefono, WhatsApp, contanti o bonifico diretto = nessuna protezione su pagamento e consegna. Segnalalo: l'admin verifica e, se confermato, ricevi <b>€ 10 di credito</b>.</div>
            </div>
          </div>
          <ReportOffPlatform orderId={orderId} viewerRole={viewerRole} />
        </div>
      )}
    </div>
  );
}
